export default "__VITE_ASSET__BrgrP5Wo__"